import {v4 as uuid } from 'uuid';

export default function launchWidget () {
    this.oauthSessionId = null;
    console.log('appClient.launchWidget() -> this.widget: ', this.widget);
    this.observed.widget = uuid();
    this.init();
    this.kickstart();
}
